import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Chip,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import {
  Person as ProfileIcon,
  AdminPanelSettings as AdminIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import LogoutButton from '../auth/LogoutButton';

const UserMenu = ({
  user,
  currentUserTenantId,
  isAdminMode,
  canAccessAdmin,
  effectiveOrgId,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="small"
        sx={{ ml: 1 }}
        aria-label="User menu"
        aria-controls={open ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Avatar
          src={user?.picture}
          alt={user?.name}
          sx={{ width: 32, height: 32 }}
        >
          {user?.name?.charAt(0)}
        </Avatar>
      </IconButton>

      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { minWidth: 200, mt: 1 } },
        }}
      >
        {/* User info header */}
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>
          <Chip
            label={user?.role || 'player'}
            size="small"
            variant="outlined"
            clickable={false}
            onClick={() => {}}
            sx={{ fontSize: '0.7rem', height: '20px', mt: 0.5 }}
          />
        </Box>
        <Divider />

        {/* My Profile */}
        {currentUserTenantId && (
          <MenuItem
            component={Link}
            to={`/player/${currentUserTenantId}`}
            onClick={handleClose}
          >
            <ListItemIcon>
              <ProfileIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>My Profile</ListItemText>
          </MenuItem>
        )}

        {/* Admin Dashboard / Exit Admin */}
        {!isAdminMode && canAccessAdmin && (
          <MenuItem
            component={Link}
            to="/admin"
            onClick={handleClose}
            sx={{ color: 'primary.main' }}
          >
            <ListItemIcon>
              <AdminIcon fontSize="small" sx={{ color: 'primary.main' }} />
            </ListItemIcon>
            <ListItemText>
              <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 500 }}>
                Admin Dashboard
              </Typography>
            </ListItemText>
          </MenuItem>
        )}
        {isAdminMode && canAccessAdmin && (
          <MenuItem
            component={Link}
            to={effectiveOrgId ? `/organization/${effectiveOrgId}` : '/'}
            onClick={handleClose}
          >
            <ListItemIcon>
              <AdminIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Exit Admin</ListItemText>
          </MenuItem>
        )}

        <Divider />

        {/* Logout */}
        <LogoutButton
          variant="text"
          size="small"
          startIcon={<LogoutIcon />}
          onClick={handleClose}
          sx={{
            color: 'inherit',
            border: 'none',
            width: '100%',
            justifyContent: 'flex-start',
            px: 2,
            py: 0.75,
            '&:hover': { backgroundColor: 'action.hover' },
          }}
        />
      </Menu>
    </>
  );
};

export default UserMenu;
